export default __webpack_public_path__ + "static/media/iran-flag03.8f9e77f8.png";